import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type StartBasicDigitalDraftTemplateQueryVariables = Types.Exact<{
  draftId: Types.Scalars['String'];
}>;

export type StartBasicDigitalDraftTemplateQuery = {
  __typename?: 'Query';
  stationeryDraftById?: { __typename?: 'StationeryDraft'; id: string; stationeryTemplate: { __typename?: 'StationeryTemplate'; id: string; themeJSON: any } } | null;
};

export const StartBasicDigitalDraftTemplateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StartBasicDigitalDraftTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryDraftById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'draftId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stationeryTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'themeJSON' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useStartBasicDigitalDraftTemplateQuery__
 *
 * To run a query within a React component, call `useStartBasicDigitalDraftTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartBasicDigitalDraftTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartBasicDigitalDraftTemplateQuery({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useStartBasicDigitalDraftTemplateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<StartBasicDigitalDraftTemplateQuery, StartBasicDigitalDraftTemplateQueryVariables>,
) {
  return ApolloReactHooks.useQuery<StartBasicDigitalDraftTemplateQuery, StartBasicDigitalDraftTemplateQueryVariables>(StartBasicDigitalDraftTemplateDocument, baseOptions);
}
export function useStartBasicDigitalDraftTemplateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StartBasicDigitalDraftTemplateQuery, StartBasicDigitalDraftTemplateQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<StartBasicDigitalDraftTemplateQuery, StartBasicDigitalDraftTemplateQueryVariables>(StartBasicDigitalDraftTemplateDocument, baseOptions);
}
export type StartBasicDigitalDraftTemplateQueryHookResult = ReturnType<typeof useStartBasicDigitalDraftTemplateQuery>;
export type StartBasicDigitalDraftTemplateLazyQueryHookResult = ReturnType<typeof useStartBasicDigitalDraftTemplateLazyQuery>;
export type StartBasicDigitalDraftTemplateQueryResult = Apollo.QueryResult<StartBasicDigitalDraftTemplateQuery, StartBasicDigitalDraftTemplateQueryVariables>;
